export default {

    salutation: "Anrede",
    sex: "Geschlecht",
    gender: "Geschlecht",
    allTakenFemale: "(Für diese Veranstaltung sind bereits alle Plätze für weiblichen Teilnehmer vergeben.)",
    allTakenMale: "(Für diese Veranstaltung sind bereits alle Plätze für männlichen Teilnehmer vergeben.)",
    contactType: "Kontaktart",
    person: "Privatperson",
    organisation: "Organisation",
    organisationName: "Name der Organisation",
    acadTitle: "Titel",
    noTitle: "Kein Titel",
    firstname: "Vorname",
    lastname: "Nachname",
    toTheAttention: "Zu Händen",
    birthday: "Geburtsdatum",
    addressType: "Adressart",
    country: "Land",
    zip: "PLZ",
    pleaseInputZipFirst: "Bitte zuerst PLZ eingeben",
    pleaseInputCityFirst: "Bitte zuerst einen Ort auswählen",
    pleaseInputStreetFirst: "Bitte zuerst eine Straße auswählen",

    city: "Ort",
    chooseCity: "Ort wählen",
    noCitiesFound: "Es konnten keine Orte gefunden werden!",
    loadCities: "Lade Orte...",

    street: "Straße",
    chooseStreet: "Straße wählen",
    loadStreets: "Lade Straßen...",
    noStreetsFound: "Es konnten keine Straßen gefunden werden!",

    houseNumber: "Hausnummer",
    postboxNumber: "Postfachnummer",
    postbox: "Postfach",

    addressAdditional: "Adresszusatz",

    isPostbox: "Adresse ist ein Postfach",

    mainAddress: "Hauptanschrift",
    address: "Anschrift",
    noAddress: "Keine Anschrift",

    phone: "Telefonnummer",
    email: "E-Mail",

    useContactForm: "Kontaktformular verwenden",

    contactSelect: {
        contact: "Kontakt",
        selectWhat: "{what} auswählen",
        searchForContact: "Nach Kontakt suchen",
        inputNameOrIdOfContact: "Name oder ID eines Kontakts eingeben",
        newContact: "Neuer Kontakt",
        noContact: "Kein Kontakt auswählen",
        input: "Eingabe",
        chosen: "Ausgewählt",
        noContactChosen: "Kein Kontakt ausgewählt",
        clickToSelect: "Klicken um Kontakt auszuwählen",
        saveAndSelect: "Speichern und auswählen"
    },

    communicationSelect: {
        email: "E-Mail",
        noEmail: "Keine E-Mail",
        phone: "Telefon",
        noPhone: "Kein Telefon",
        mobile: "Mobiltelefon",
        noMobile: "Kein Mobiltelefon"
    },

    bankDetails: {
        label: "Bankverbindung",
        preferred: "Bevorzugt",
        invalid: "Die Bankverbindung ist ungültig, die zugehörige Bankleitzahl wurde gelöscht.",
        hasSepaMandate: "SEPA Mandat vorhanden",
        noBankDetails: "Keine Bankverbindung",
    },

    edit: "bearbeiten"

}
